module.exports = __webpack_public_path__ + "media/images/trash-e8f6056be0d5dacca882424b20c20518.svg";